import { render, staticRenderFns } from "./AbaIntegracao.vue?vue&type=template&id=7ad96a4d&scoped=true&"
import script from "./AbaIntegracao.vue?vue&type=script&lang=js&"
export * from "./AbaIntegracao.vue?vue&type=script&lang=js&"
import style0 from "./AbaIntegracao.vue?vue&type=style&index=0&id=7ad96a4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad96a4d",
  null
  
)

export default component.exports